import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=0ddd8eed&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=ts"
export * from "./BackToTop.vue?vue&type=script&lang=ts"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=0ddd8eed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd8eed",
  null
  
)

export default component.exports